/* Pause controls and Shopify editor support for the product-review marquee. */
(function () {
  "use strict";
  if (window.__saeProductReviewEventsInstalled) return;
  window.__saeProductReviewEventsInstalled = true;

  function initialize(scope) {
    scope.querySelectorAll("[data-sae-product-reviews]").forEach(function (section) {
      if (section.dataset.saeReviewsInitialized === "true") return;
      section.dataset.saeReviewsInitialized = "true";
      section.dataset.pageHidden = String(document.hidden);
      var button = section.querySelector("[data-sae-reviews-pause]");
      if (!button) return;
      button.hidden = false;
      function updateButton() {
        var paused = section.dataset.userPaused === "true" || section.dataset.autoScroll === "false";
        button.setAttribute("aria-pressed", String(paused));
        var label = button.querySelector("[data-sae-reviews-pause-label]");
        if (label) label.textContent = paused ? "Resume reviews" : "Pause reviews";
      }
      updateButton();
      button.addEventListener("click", function () {
        if (section.dataset.autoScroll === "false") {
          section.dataset.autoScroll = "true";
          section.dataset.userPaused = "false";
        } else {
          section.dataset.userPaused = String(section.dataset.userPaused !== "true");
        }
        updateButton();
      });
    });
  }

  function editorSelection(event, selected) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    var section = target.closest("[data-sae-product-reviews]") || target.querySelector("[data-sae-product-reviews]");
    if (!section) return;
    section.dataset.editorSelected = String(selected);
    if (selected && event.detail && event.detail.blockId) {
      section.querySelectorAll("[data-sae-review-block]").forEach(function (card) {
        if (card.dataset.saeReviewBlock === event.detail.blockId) {
          card.scrollIntoView({ block: "nearest", inline: "center", behavior: "auto" });
        }
      });
    }
  }

  initialize(document);
  document.addEventListener("shopify:section:load", function (event) { initialize(event.target); });
  // Selecting the whole section keeps the moving preview running.
  document.addEventListener("shopify:block:select", function (event) { editorSelection(event, true); });
  document.addEventListener("shopify:section:deselect", function (event) { editorSelection(event, false); });
  document.addEventListener("shopify:block:deselect", function (event) { editorSelection(event, false); });
  document.addEventListener("visibilitychange", function () {
    document.querySelectorAll("[data-sae-product-reviews]").forEach(function (section) {
      section.dataset.pageHidden = String(document.hidden);
    });
  });
})();
